import { render, staticRenderFns } from "./bpa.vue?vue&type=template&id=2fb22a43&scoped=true&"
import script from "./bpa.vue?vue&type=script&lang=js&"
export * from "./bpa.vue?vue&type=script&lang=js&"
import style0 from "./bpa.vue?vue&type=style&index=0&id=2fb22a43&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb22a43",
  null
  
)

export default component.exports